// Eligibility stub for the cash-fund hotel-search variant.
//
// TODO(TRAV-3348 follow-up): replace this static `true` with the real cash-fund balance query
// once the backend is ready. This is the single swap point for the balance gate — keep all
// callers reading through this hook so the future query lands in exactly one place.
export const useCashFundEligibility = (): boolean => true;
